import(/* webpackMode: "eager" */ "/opt/render/project/src/app/[locale]/sitemap/error.tsx");
